import { render, staticRenderFns } from "./ProposedPayPlanDrawer.vue?vue&type=template&id=48577cad&scoped=true"
import script from "./ProposedPayPlanDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposedPayPlanDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProposedPayPlanDrawer.vue?vue&type=style&index=0&id=48577cad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48577cad",
  null
  
)

export default component.exports